import StarterKit from "@tiptap/starter-kit";
import {
    Attributes,
    BlockDiffRemoved, CommentMark, CommentSelectionExtension,
    CustomBulletList,
    CustomOrderedList, CustomTable, DiffAdded,
    DiffModified, DiffRemoved, LineHeight, Margin, NodeIdPlugin, PreserveMarks, VariableListNode, VariableNode,
    VariableSuggestion, VariableTableExtension
} from "../components/DocumentEditor/Extensions";
import {PaginationPlus} from "tiptap-pagination-plus";
import {TextAlign} from "@tiptap/extension-text-align";
import {TableRow} from "@tiptap/extension-table-row";
import {TableHeader} from "@tiptap/extension-table-header";
import {TableCell} from "@tiptap/extension-table-cell";
import TextStyle from "@tiptap/extension-text-style";
import {Underline} from "@tiptap/extension-underline";
import {Color} from "@tiptap/extension-color";
import {useEditor} from "@tiptap/react";
import {TextSelection} from "prosemirror-state";
import {handleSelectionChange} from "../utils/Utils";

export const useDocumentEditor = (setTableModal, blockSaveRef, debounceOnUpdate, variablesRef, setCommentButtonPos, setLastSelection) => {
    return  useEditor({
        extensions: [
            StarterKit.configure({orderedList: false, bulletList: false}),
            Attributes,
            CustomOrderedList,
            CustomBulletList,
            BlockDiffRemoved,
            PaginationPlus.configure({
                pageHeight: 1000,
                pageWidth: 730,
                pageGap: 30,
            }),
            TextAlign.configure({
                types: ["paragraph", "heading", "orderedList", "bulletList"],
                defaultAlignment: "left",
            }),
            CustomTable.configure({
                resizable: true,
            }),
            VariableTableExtension.configure({
                onTable: (node) => {
                    setTableModal(node.attrs);
                },
            }),
            TableRow,
            TableHeader,
            TableCell,
            TextStyle,
            Underline,
            Color,
            LineHeight,
            Margin,
            VariableNode,
            VariableListNode,
            VariableSuggestion.configure({
                getVariables: () => variablesRef.current ?? {},
                onTable: () => setTableModal({})
            }),
            Margin,
            DiffAdded,
            DiffRemoved,
            DiffModified,
            CommentMark.configure({
                onExitComment: (editor) => {
                    editor.chain().focus().setColor("#3b3b3b").run();

                    editor.view.dispatch(
                        editor.view.state.tr
                            .setStoredMarks([])
                            .setSelection(TextSelection.create(editor.view.state.doc, editor.view.state.selection.from))
                    );
                }
            }),
            CommentSelectionExtension.configure({
                onSelectionChange: (editor) => {
                    if (!editor) {
                        setCommentButtonPos(null);
                        return;
                    }

                    handleSelectionChange(
                        setCommentButtonPos,
                        blockSaveRef,
                        editor,
                        setLastSelection
                    );
                },
            }),
            VariableTableExtension.configure({
                onTable: (node) => setTableModal(node.attrs),
            }),
            PreserveMarks
        ],
        content: '<p></p>',
        onUpdate: ({editor}) => {
            if (blockSaveRef.current) return;

            debounceOnUpdate({editor});
        },
        onCreate: ({editor}) => {
            editor.registerPlugin(NodeIdPlugin);
        },
    })
}